import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

interface Props {
  title: string;
  data?: any;
  value?: any;
  isRequired?: boolean;
  isMultiple?: boolean;
  isDisabled?: boolean;
  isVertical?: boolean;
  titleClassNames?: string;
  inputClassNames?: string;
  containerClassNames?: string;
  onChangeHandler?: ((event: any) => void) | ((event: any) => void)[]; // Can accept one function or an array of functions
  formikError?: any;
  formikTouch?: any;
}

const DropDownField: React.FC<Props> = ({
  title,
  data,
  value,
  isRequired = false,
  isMultiple = false,
  isDisabled = false,
  isVertical = false,
  titleClassNames = '',
  inputClassNames = '',
  containerClassNames = '',
  onChangeHandler,
  formikError,
  formikTouch,
}) => {
  // Create a function to call each function in onChangeHandler if it's an array
  const handleOnChange = (event: any) => {
    if (Array.isArray(onChangeHandler)) {
      onChangeHandler.forEach(handler => handler(event)); // Call each function in the array
    } else if (onChangeHandler) {
      onChangeHandler(event); // If it's a single function, call it directly
    }
  };
  return (
    <div
      className={`flex flex-row 
      ${containerClassNames ? containerClassNames : `mt-5`} 
      ${isVertical ? `flex-col items-start` : ``}`}
    >
      <div
        className={`font-medium text-base flex-shrink-0 mr-5 
        ${titleClassNames ? titleClassNames : 'w-48'}`}
      >
        {title}
        {isRequired && <span className="text-red-500">*</span>}
      </div>
      <div className="w-full">
        <Select
          style={{ display: 'inline-grid', overflow: 'hidden' }}
          value={value}
          defaultValue={''}
          multiple={isMultiple}
          disabled={isDisabled}
          onChange={handleOnChange}
          className={`h-10 rounded-md font-normal text-base text-black
          ${isDisabled ? 'bg-gray-300' : 'bg-transparent'}
            ${inputClassNames ? inputClassNames : `w-full`}`}
        >
          {!isMultiple && <MenuItem value={''}>Select Option</MenuItem>}
          {Array.isArray(data) &&
            data?.map((item: any, index: any) => (
              <MenuItem key={index} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
        </Select>
        {formikError && formikTouch && (
          <div className="text-red-500 text-xs mt-1">{formikError}</div>
        )}
      </div>
    </div>
  );
};

export default DropDownField;
